module.exports = __webpack_public_path__ + "static/media/jnjl_image.36632cd3.png";